import dt from 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';

// Fancy popups
import Swal from 'sweetalert2'

function toggle(className, displayState){
    var elements = document.getElementsByClassName(className);
    for (var i = 0; i < elements.length; i++){
        elements[i].style.display = displayState;
    }
}

// Entity-escape a value before it is concatenated into HTML. Names and room
// numbers come from residents and the post location from any staff member,
// so every column must pass through here (F02, G6.1).
function escapeHtml(value) {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

// "Name" over "room" for the collected-by cell, built here from plain values
// so the markup is ours and the values are escaped.
function collectedByHtml(name, room) {
    if (!name) {
        return '';
    }
    return escapeHtml(name) + (room ? '<br /><small>' + escapeHtml(room) + '</small>' : '');
}

/**
 * The first validation message in a refused (422) JSON reply, or a fallback.
 * A 404 (the parcel is no longer on the selected property) or a server error
 * carries nothing worth showing.
 */
function firstServerError(xhr, fallback) {
  if (!xhr || xhr.status === 404 || xhr.status >= 500) { return fallback; }
  var body = xhr.responseJSON;
  if (body && body.errors) {
    var messages = [].concat.apply([], Object.keys(body.errors).map(function (k) { return body.errors[k]; }));
    if (messages.length) { return messages[0]; }
  }
  return (body && body.message) ? body.message : fallback;
}

/** Redraw the table so a row shows the server's real state, keeping the page. */
function reloadParcelsTable() {
  if ($.fn.dataTable.isDataTable('.hfs-data-parcel-collections-table')) {
    $('.hfs-data-parcel-collections-table').DataTable().ajax.reload(null, false);
  }
}

document.addEventListener('DOMContentLoaded', function() {
/** 
   * Generic user datatable configuration for events table /events
   */
  if(document.getElementsByClassName('hfs-data-parcel-collections-table').length > 0){

    if(getParameterByName('filter') == 2 || getParameterByName('filter') == 4){

      var columns = [
        {
          data: 'created_at',
          className: 'align-middle',
          width: 100,
          render: function(data) { return escapeHtml(data); }
        },
        {
          data: 'code',
          className: 'align-middle',
          width: 55,
          render: function(data) { return escapeHtml(data); }
        },
        {
          data: 'post_location',
          className: 'align-middle',
          width: 100,
          render: function(data) { return escapeHtml(data); }
        },
        {
          data: 'room_number',
          className: 'align-middle',
          width: 130,
          render: function(data) { return escapeHtml(data); }
        },
        { 
          data: 'first_name',
          className: 'align-middle',
          width: 155,
          render: function(data, type, row) {
            var userHTML = `
            <div class="d-flex">
              <div class="d-flex flex-column justify-content-center">
                <h6 class="mb-0 text-xs">`+escapeHtml(data)+`</h6>
              </div>
            </div>`;
            return userHTML;
          }
        },
        { 
          data: 'last_name',
          className: 'align-middle',
          width: 155,
          render: function(data, type, row) {
            var userHTML = `
            <div class="d-flex">
              <div class="d-flex flex-column justify-content-center">
                <h6 class="mb-0 text-xs">`+escapeHtml(data)+`</h6>
              </div>
            </div>`;
            return userHTML;
          }
        },
        {
          data: 'created_by',
          className: 'align-middle',
          width: 200,
          render: function(data) { return escapeHtml(data); }
        },
        {
          data: 'collected_at',
          className: 'align-middle',
          width: 125,
          render: function(data) { return escapeHtml(data); }
        },
        { 
          data: 'collected_by',
          className: 'align-middle',
          width: 200,
          render: function(data, type, row) {
            return '<span class="data-collected-by-row-'+row.id+'">'+collectedByHtml(data, row.collected_by_room)+'</span>';
          }
        },
        { 
          data: 'status',
          className: 'align-middle',
          render: function(data, type, row) {
  
            if(data.id == 1){
              return '<span class="badge bg-warning text-white data-collection-badge-'+row.id+'">'+escapeHtml(data.name)+'</span>';
            }else if(data.id == 2){
              return '<span class="badge bg-success text-white data-collection-badge-'+row.id+'">'+escapeHtml(data.name)+'</span>';
            }else if(data.id == 3){
              return '<span class="badge bg-danger text-white data-collection-badge-'+row.id+'">'+escapeHtml(data.name)+'</span>';
            }else if(data.id == 5){
              return '<span class="badge bg-info text-white data-collection-badge-'+row.id+'">'+escapeHtml(data.name)+'</span>';
            }
  
          },
          width: 200
        },
        { 
          data: 'actions', 
          render: function(data, type, row){
            return collectionButtons(data, type, row);
          },
          className: 'align-middle text-end',
          width: 500
        },
        ];

    }else{

      var columns = [
      {
        data: 'created_at',
        className: 'align-middle',
        width: 100,
        render: function(data) { return escapeHtml(data); }
      },
      {
        data: 'code',
        className: 'align-middle',
        width: 55,
        render: function(data) { return escapeHtml(data); }
      },
      {
        data: 'post_location',
        className: 'align-middle',
        width: 100,
        render: function(data) { return escapeHtml(data); }
      },
      {
        data: 'room_number',
        className: 'align-middle',
        width: 130,
        render: function(data) { return escapeHtml(data); }
      },
      { 
        data: 'first_name',
        className: 'align-middle',
        width: 155,
        render: function(data, type, row) {
          var userHTML = `
          <div class="d-flex">
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-xs">`+escapeHtml(data)+`</h6>
            </div>
          </div>`;
          return userHTML;
        }
      },
      { 
        data: 'last_name',
        className: 'align-middle',
        width: 155,
        render: function(data, type, row) {
          var userHTML = `
          <div class="d-flex">
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-xs">`+escapeHtml(data)+`</h6>
            </div>
          </div>`;
          return userHTML;
        }
      },
      {
        data: 'created_by',
        className: 'align-middle',
        width: 200,
        render: function(data) { return escapeHtml(data); }
      },
      { 
        data: 'collected_at',
        className: 'align-middle',
        width: 125,
        render: function(data, type, row) {
          return '<span class="data-collected-at-row-'+row.id+'">'+escapeHtml(data)+'</span>';
        }
      },
      { 
        data: 'collected_by',
        className: 'align-middle',
        width: 200,
        render: function(data, type, row) {
          return '<span class="data-collected-by-row-'+row.id+'">'+collectedByHtml(data, row.collected_by_room)+'</span>';
        }
      },
      { 
        data: 'status',
        className: 'align-middle',
        render: function(data, type, row) {

          if(data.id == 1){
            return '<span class="badge bg-warning text-white data-collection-badge-'+row.id+'">'+escapeHtml(data.name)+'</span>';
          }else if(data.id == 2){
            return '<span class="badge bg-success text-white data-collection-badge-'+row.id+'">'+escapeHtml(data.name)+'</span>';
          }else if(data.id == 3){
            return '<span class="badge bg-danger text-white data-collection-badge-'+row.id+'">'+escapeHtml(data.name)+'</span>';
          }else if(data.id == 5){
            return '<span class="badge bg-info text-white data-collection-badge-'+row.id+'">'+escapeHtml(data.name)+'</span>';
          }

        },
      },
      
      { 
        data: 'actions', 
        render: function(data, type, row){
          return collectionButtons(data, type, row);
        },
        className: 'align-middle text-end',
        width: 500
      },
      ];

    }

    var numDaysBetween = function(d1, d2) {
      var diff = Math.abs(d1.getTime() - d2.getTime());
      return Math.round(diff / (1000 * 60 * 60 * 24));
    };

    function collectionButtons(data, display, row){

      var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
 
      if(row.awaiting_collection){

        if(row.status.id == 3){


          var btnDisabled = false;

          if(row.reminder_count == null || row.reminder_count == 0) {
            var reminderNo = '1st';
          }else if(row.reminder_count == 1) {
            var reminderNo = '2nd';
          }else if(row.reminder_count == 2) {
            var reminderNo = '3rd';
          }else if(row.reminder_count == 3){
            var btnDisabled = true;
          }
          
          if(!btnDisabled){
            
            var allowReminder = false;

            // The server sends '-' (not null) for a never-reminded parcel; treating
            // it as a date made the gate below never pass, so the FIRST reminder
            // could never be sent (MT-048).
            // Whether three days have passed since the last reminder is the
            // server's call (G6.3): the same rule that accepts or refuses.
            allowReminder = !!row.reminder_gap_elapsed;

            if(allowReminder){

              var additionalBtn = `<button class="btn btn-danger text-white btn-sm btn-parcel-collections-send-reminder" 
              data-collection-id="`+row.id+`" 
              data-collection-name="`+escapeHtml(row.resident)+`"
              data-collection-resident-id="`+row.user_id+`"
              title="Mark as collected">
              <i class="fa-regular fa-circle-question fa-fw"></i> Send `+reminderNo+` Reminder
              </button>`;
            
            } else {

              var additionalBtn = `<button class="btn btn-danger text-white btn-sm" 
              title="Reminder Sent"
              disabled="disabled">
              <i class="fa-regular fa-circle-check fa-fw"></i> Reminder Sent
              </button>`;
            }
            
            
          }else{

            // The server sends '-' (not null) for a never-reminded parcel; treating
            // it as a date made the gate below never pass, so the FIRST reminder
            // could never be sent (MT-048).
            if(row.reminder_gap_elapsed){
              var additionalBtn = `<button class="btn btn-parcel-collections-unable-to-contact btn-danger text-white btn-sm" 
              title="Unable to Contact"
              data-collection-id="`+row.id+`" 
              data-collection-code="`+escapeHtml(row.code)+`"
              data-collection-name="`+escapeHtml(row.resident)+`"
              data-collection-resident-id="`+row.user_id+`"
              >
                <i class="fa-solid fa-rotate-left fa-fw"></i> Unable to Contact
              </button>`;
            }else{
              var additionalBtn = `<button class="btn btn-danger text-white btn-sm" 
              title="Reminder Sent"
              disabled="disabled">
                <i class="fa-solid fa-triangle-exclamation fa-fw"></i> Reminder Sent
              </button>`;
            }
            
          }

        }else{
          var additionalBtn = '';
        }

        var btnHTML = `
        <div class="btn-group btn-group-collections">
          <button class="btn btn-primary text-white btn-sm btn-parcel-collections-mark-collected" 
          data-collection-id="`+row.id+`" 
          data-collection-name="`+escapeHtml(row.resident)+`"
          data-collection-resident-id="`+row.user_id+`"
          title="Mark as collected">
            <i class="fa fa-check-circle fa-fw"></i> Mark as Collected
          </button>`+additionalBtn+`
        </div>`;

      }else{
        if(parseInt($('#hidden_user_level_id').val()) == 3){

          var btnHTML = `
          <div class="btn-group btn-group-collections">
            <button class="btn btn-secondary text-white btn-sm btn-parcel-collections-mark-uncollected" 
            data-collection-id="`+row.id+`" 
            data-collection-name="`+escapeHtml(row.resident)+`"
            data-collection-resident-id="`+row.user_id+`"
            title="Mark as Uncollected">
            <i class="fa-solid fa-fw fa-arrow-right-arrow-left"></i> Mark as Uncollected
            </button>
          </div>`;

        }else{
          var btnHTML = '&#8212;';
        }
      }
      return btnHTML;
    };

    let table = new dt('.hfs-data-parcel-collections-table', {
      // processing: true,
      serverSide: true,
      lengthMenu: [ [25, 50, 50, 100, 200], [25, 50, 50, 100, 200] ],
      columns: columns,
      rowId: 'id',
      order: [[ 0, 'desc' ]],
      ajax: '/parcel-collections/ajax/json?filter='+getParameterByName('filter')+'&resident='+getParameterByName('resident'),
      "autoWidth": false,
      "responsive": {
        details: {
            type: 'column',
            target: 'tr'
        }
      },
      "initComplete": function(settings, json) {
          toggle('hfs-spinner', 'none');
          toggle('hfs-table', 'table');
          toggle('hfs-card-nav', 'flex');
      }
    });

    $(".resident-selection-dropdown")
    .select2({
        theme: "bootstrap-5",
        placeholder: 'Please choose resident...'
    });

    $('.resident-selection-dropdown')
    .on('select2:select', function (e) {
      var data = e.params.data;
      if(data.id == '0') {
        // default
        window.location.href = '/parcel-collections?filter='+getParameterByName('filter');
      }else{
        window.location.href = '/parcel-collections?filter='+getParameterByName('filter')+'&resident='+data.id;
      }
    });

    $(document).on('click', '.btn-parcel-collections-unable-to-contact', function(e){
      e.preventDefault();
      let thisEle = $(this);
      let collectionId = $(this).data('collection-id');
      let collectionName = $(this).data('collection-name');
      let collectionCode = $(this).data('collection-code');
    


      Swal.fire({
        title: 'Confirm',
        // data() hands back the decoded attribute, so escape again for the HTML sink.
        html: 'Are you sure you want to mark this parcel for '+escapeHtml(collectionName)+' with the collection code "'+escapeHtml(collectionCode)+'" as unable to contact?',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: window.kliqPrimaryColour(),
        cancelButtonColor: '#d33',
        confirmButtonText: 'Mark as Unable to Contact'
      }).then((result) => {

        if (result.isConfirmed) {
          thisEle.html('<i class="fas text-white fa-circle-notch fa-spin"></i> Marking as Unable to Contact...');
          $.ajax({
            url: '/parcel-collections/markUnableToContact',
            method: 'POST',
            data: {
              collectionId: collectionId,
              _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            success: function(response) {

              if(response.success) {
        // Redraw the row so its real next actions appear instead of an inert
        // rewritten button (MT-071); keep the current page.
        if ($.fn.dataTable.isDataTable('.hfs-data-parcel-collections-table')) {
          $('.hfs-data-parcel-collections-table').DataTable().ajax.reload(null, false);
        }
                thisEle.html('<i class="fa text-white fa-circle-check"></i> Marked as Unable to Contact');
                thisEle.prop('disabled', 'disabled');
              }else{
                reloadParcelsTable();
                Swal.fire('Not changed', escapeHtml(response.message || 'The parcel could not be updated.'), 'error');
              }

            },
            error: function(xhr){
              reloadParcelsTable();
              Swal.fire('Not changed', escapeHtml(firstServerError(xhr, 'The parcel could not be updated.')), 'error');
            }
          })
        }
      });
    })

    $(document).on('click', '.btn-parcel-collections-mark-uncollected', function(e){
      e.preventDefault();
      let thisEle = $(this);

      let collectionId = $(this).data('collection-id');
      let collectionName = $(this).data('collection-name');
      let collectionUserId = $(this).data('collection-resident-id');

      Swal.fire({
        title: 'Confirm',
        html: 'Are you sure you want to mark this parcel as Uncollected?',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: window.kliqPrimaryColour(),
        cancelButtonColor: '#d33',
        confirmButtonText: 'I Confirm'
      }).then((result) => {

        if (result.isConfirmed) {

          thisEle.html('<i class="fas text-white fa-circle-notch fa-spin"></i> Marking as Uncollected...');
          markParcelAsUnCollected(collectionId, thisEle);
        }

      });
    });

    $(document).on('click', '.btn-parcel-collections-mark-collected', function(e){
      
      let collectionId = $(this).data('collection-id');
      let collectionName = $(this).data('collection-name');
      let collectionUserId = $(this).data('collection-resident-id');

      let residents = JSON.parse($('#residentsJson').html());
      let residentsHtml = '';


      for (let index = 0; index < residents.length; index++) {
        const element = residents[index];
        residentsHtml += '<option value="'+element.id+'"';
        if(collectionUserId == element.id) {
          residentsHtml += ' selected';
        }
        residentsHtml += '>'+escapeHtml(element.name)+' ('+escapeHtml(element.room_number)+')</option>';
      }
      
      var now = new Date();
      now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
      let dateTimeNow = now.toISOString().slice(0,16);

      let confirmCollectionHTML = `
      Are you sure you want to mark this parcel as collected for the resident `+escapeHtml(collectionName)+`?
      <div class="mt-3">
        <div class="input-group">
          <div class="input-group-text" style="width: 182px;">
            Resident Collecting:
          </div>
          <select class="form-control collecting-user-select" name="collecting_resident">
          `+residentsHtml+`
          </select>
        </div>
      </div>
      <div class="mt-3">
        <div class="input-group">
          <div class="input-group-text" style="width: 182px;">
            Date / Time Collected:
          </div>
          <input class="form-control" value="`+dateTimeNow+`" name="dateTimeCollected" type="datetime-local">
        </div>
      </div>`;

      

      Swal.fire({
        title: 'Confirm',
        html: confirmCollectionHTML,
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: window.kliqPrimaryColour(),
        cancelButtonColor: '#d33',
        confirmButtonText: 'Mark as Collected'
      }).then((result) => {

        if (result.isConfirmed) {
          let selectedCollector = $('.collecting-user-select').select2('data');
          let collectedDateTime = $('input[name=dateTimeCollected]').val();

          markParcelAsCollected(collectionId, selectedCollector[0].id, collectedDateTime);
        }

        $(".collecting-user-select").select2('destroy');

      });

      //setTimeout(function(){
        
        // $(".collecting-user-select").select2('destroy');

        $(".collecting-user-select")
        .select2({
          theme: "bootstrap-5",
          placeholder: 'Please choose resident...'
        });

      //  },500);

    });

    $(document).on('click', '.btn-parcel-collections-send-reminder', function(e){
      
      let thisEle = $(this);
      let collectionId = $(this).data('collection-id');
      let collectionName = $(this).data('collection-name');

      Swal.fire({
        title: 'Confirm',
        html: 'Are you sure you wish to send '+escapeHtml(collectionName)+' a post reminder?',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: window.kliqPrimaryColour(),
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send Reminder'
      }).then((result) => {

        if (result.isConfirmed) {
          thisEle.html('<i class="fas text-white fa-circle-notch fa-spin"></i> Sending Reminder...');
          $.ajax({
            url: '/parcel-collections/sendReminder',
            method: 'POST',
            data: {
              collectionId: collectionId,
              _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            success: function(response) {

              if(response.success) {
        // Redraw the row so its real next actions appear instead of an inert
        // rewritten button (MT-071); keep the current page.
        if ($.fn.dataTable.isDataTable('.hfs-data-parcel-collections-table')) {
          $('.hfs-data-parcel-collections-table').DataTable().ajax.reload(null, false);
        }
                thisEle.html('<i class="fa text-white fa-circle-check"></i> Reminder Sent');
                thisEle.prop('disabled', 'disabled');
              }else{
                reloadParcelsTable();
                Swal.fire('Not sent', escapeHtml(response.message || 'The reminder could not be sent.'), 'error');
              }

            },
            error: function(xhr){
              reloadParcelsTable();
              Swal.fire('Not sent', escapeHtml(firstServerError(xhr, 'The reminder could not be sent.')), 'error');
            }
          })
        }else{
          // user cancelled
        }

      });

    });

  }



});

function markParcelAsUnCollected(collectionId, thisElement)
{
  $.ajax({
    url: '/parcel-collections/uncollect',
    data: {
      _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      collectionId: collectionId,
    },
    method: 'POST',
    success: function(response) {

      if(response.success){
        // Redraw the row so its real next actions appear instead of an inert
        // rewritten button (MT-071); keep the current page.
        if ($.fn.dataTable.isDataTable('.hfs-data-parcel-collections-table')) {
          $('.hfs-data-parcel-collections-table').DataTable().ajax.reload(null, false);
        }

        thisElement.html('<i class="fas text-white fa-check-circle"></i> Marked as Uncollected');

        Swal.fire(
          'Parcel marked as Uncollected',
          'The selected parcel has been marked as uncollected.',
          'success'
        );
      }else{
        reloadParcelsTable();
        Swal.fire(
          'Error',
          escapeHtml(response.message),
          'error'
        );
      }

    },
    error: function(xhr){
      reloadParcelsTable();
      Swal.fire('Not changed', escapeHtml(firstServerError(xhr, 'The parcel could not be updated.')), 'error');
    }
  })
}

function markParcelAsCollected(collectionId, collectedBy, collectedDateTime)
{
  $.ajax({
    url: '/parcel-collections',
    data: {
      _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      collectionId: collectionId,
      collectedBy: collectedBy,
      collectedAt: collectedDateTime
    },
    method: 'POST',
    success: function(response){
      
      if(response.success) {
        // Redraw the row so its real next actions appear instead of an inert
        // rewritten button (MT-071); keep the current page.
        if ($.fn.dataTable.isDataTable('.hfs-data-parcel-collections-table')) {
          $('.hfs-data-parcel-collections-table').DataTable().ajax.reload(null, false);
        }

        Swal.fire(
          'Parcel marked as collected',
          'The selected parcel has been marked as collected.',
          'success'
        );

        // remove btn
        $('[data-collection-id='+collectionId+']').remove();
        $('.data-collection-badge-'+collectionId).removeClass('bg-danger');
        $('.data-collection-badge-'+collectionId).removeClass('bg-warning');
        $('.data-collection-badge-'+collectionId).addClass('bg-success');
        $('.data-collection-badge-'+collectionId).text('Collected');
        $('.data-collected-at-row-'+collectionId).text(response.collectedAt);
        $('.data-collected-by-row-'+collectionId).html(collectedByHtml(response.collectedBy, response.collectedByRoom));
          
      }else{
        reloadParcelsTable();
        Swal.fire(
          'Error marking as collected',
          escapeHtml(response.message || 'The selected could not be marked, please contact support.'),
          'error'
        );
      }

    },
    error: function(xhr){
      reloadParcelsTable();
      Swal.fire('Not changed', escapeHtml(firstServerError(xhr, 'The parcel could not be marked as collected.')), 'error');
    }
  })
}

/**
 * URL Param by name (eg. ?parcelManager=true)
 */
 function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
